import i18n from 'i18next';
import moment from 'moment';

const spliceFirstString = (string) => {
  return string.substring(0, 1).toUpperCase();
};

//截取url参数
const getQueryVariable = (variable) => {
  const query = window.location.search.substring(1);
  console.log('getQueryVariable:', query)
  console.log('window.location:', window.location)
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return '';
};

//截取字符串中参数
const getStrQueryVariable = (variable, str) => {
  const query = str.split('?')[1];
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return false;
};

const mobileCheck = () => {
  let check = false;
  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

/**
 * 联网方式
 */
const NetworkType = {
  AliBabaIoT: 2,  //阿里IoT
  CustomMQTT: 1,  //自建MQTT
};


/**
 *  加密方式定义
 */
const EncryptType = {
  NoEncrypt: 0,   //不加密
  FixedEncrypt: 1, //固定加密
};

function formatTime(minutes) {
  if (minutes === 1) {
    return `1 ${ i18n.t('minute') }`;
  }
  if (minutes === 60) {
    return `1 ${ i18n.t('hour') }`;
  }
  const hour = minutes / 60;
  if (hour < 1) {
    return `${ minutes } ${ i18n.t('minutes') }`;
  }

  return `${ hour } ${ i18n.t('hours') }`;
}

function formatNetType(networkType) {
  if (networkType === NetworkType.AliBabaIoT) {
    return i18n.t('ali_iot');
  }
  return i18n.t('custom_mqtt');
}

function formatEncryptType(encryptType) {
  if (encryptType === EncryptType.NoEncrypt) {
    return i18n.t('no_encrypt');
  }
  return i18n.t('fixed_encrypt');
}

function formatTimestamp(timestamp) {
  if (timestamp < 10) {
    return '-';
  }
  return moment.unix(timestamp).format('yyyy/MM/DD HH:mm');
}

function changedConfigSuccessTip(code) {
  // switch (code) {
  //   case 'CGP1W':  //青萍温湿度气压计 Wi-Fi 版
  //   case 'CGP23W': //青萍商用温湿度气压计 S Wi-Fi 版
  //   case 'CGF1W':  //"青萍商用温湿度计 E Wi-Fi 版
  //     return i18n.t('device_wifi_edit_success');
  //   default:
  // }
  return i18n.t('device__edit_success');
}

function getCollectionConfig(code) {
  switch (code) {
    case 'CGS1': // Snow
    case 'CGDN1': //Dany
      return {
        collectInterval: 15,
        reportInterval: 15,
      };
    default:
      return {
        collectInterval: 15,
        reportInterval: 60,
      };
  }
}

export {
  spliceFirstString,
  getQueryVariable,
  getStrQueryVariable,
  mobileCheck,
  NetworkType,
  EncryptType,
  formatTime,
  formatNetType,
  formatEncryptType,
  formatTimestamp,
  changedConfigSuccessTip,
  getCollectionConfig,
};
